import type {
  AgGridRowData,
  AgGridTransactionRef
} from './types';

export const updateTransaction = (
  newRows: AgGridRowData[] | null | undefined,
  gridRef: AgGridTransactionRef | null | undefined
): AgGridRowData[] => {
  const api = gridRef?.current?.api;
  if (api && newRows && Array.isArray(newRows)) {
    const newRowsForTransaction: AgGridRowData[] = [];
    newRows.forEach(row => {
      const existingData = api.getRowNode(row.id as string)?.data;
      if (existingData)
        newRowsForTransaction.push({
          ...existingData,
          ...row
        });
    });
    api.applyServerSideTransaction({
      update: newRowsForTransaction
    });
    return newRowsForTransaction;
  } else return [];
};
